import api from '@/api'

export default class HomeApi {
	static async init(data) {
		return api.post('/index', data).then(function (response) {
			return response.data
		})
	}
}
